import { Theme, Typography, withStyles } from '@material-ui/core'
import { withTranslation, Trans } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { navigate } from '../../../actions/routes'
import { Navigate } from '../../../actions/types'
import { signup } from '../../../actions/users'
import { MuiClasses } from '../../../types'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import Dialog from '../../Dialog'
import SignupForm from './SignupForm'

const styles = ({ spacing }: Theme) => ({
  form: {
    margin: '10px auto',
    padding: spacing(),
    maxWidth: '500px'
  },
  errorMessage: {
    color: 'red',
    marginTop: '10px'
  }
})

type SignupProps = {
  classes: MuiClasses
  doSignup: () => any
  errorCode: string
  t: (arg: string) => any
  navigateToPath: Navigate
}

const Signup = ({ classes, doSignup, t, navigateToPath }: SignupProps) => (
  <div className={classes.form}>
    <Typography variant='h6' gutterBottom>
      {t('signup.signup')}
    </Typography>
    <Typography variant='body1' gutterBottom>
      <Trans i18nKey='signup.orLogin'>
        <Link to='/'></Link>
      </Trans>
    </Typography>
    <SignupForm signup={doSignup} />
    <Dialog
      dialogId={'SignupSuccess'}
      title={t('signup.successDialog.title')}
      noOpenDialogButton
      onlyConfirmCloses
      confirmDialogSubmitAction={() => navigateToPath('/')}
      Content={
        <div className={classes.dialogContent}>
          <Typography variant='body1' gutterBottom>
            {t('signup.successDialog.p0')}
          </Typography>
          <br />
          <Typography variant='body1' gutterBottom>
            {t('signup.successDialog.p1')}
          </Typography>
        </div>
      }
    />
  </div>
)

// const mapStateToProps = (state: { [key: string]: any }) => ({
//   // isSignupDone: selectIsSignupDone(state),
//   // errorCode: selectSignupErrorCode(state)
// })

const mapDispatchToProps = (dispatch: (arg: any) => any) => ({
  doSignup: bindSubmitActionToPromise(dispatch, signup),
  navigateToPath: (path: string) => dispatch(navigate(path))
})

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(Signup as any)))
